import Typography from '@mui/material/Typography';
import { RoomShoppable } from '@pages/shop/homes/[home]/home';
import React from 'react';

import useStyles from './ShoppableRoomPhoto.style';

type RoomPhotoProps = {
  pseudoRoom: RoomShoppable;
}

const ShoppableRoomPhoto = (props: RoomPhotoProps) => {
  const { pseudoRoom } = props;
  const { cartRoomProduct } = pseudoRoom;
  
  const primaryPhoto = cartRoomProduct.room?.primaryPhoto;
  
  const { classes } = useStyles();

  if (!pseudoRoom.roomDocID) {
    return null;
  }

  return (
    <>
      {primaryPhoto &&  
      <div className={classes.carouselPhotoContainer}>
        <div className={classes.roomInfoContainer}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography className={classes.roomTitle}>
              {cartRoomProduct.room.title}
            </Typography>
          </div>
        </div>

        <img
          className={classes.primaryPhoto}
          src={primaryPhoto.large_url}
        />
      </div>
      }
    </>
  );
};

export default ShoppableRoomPhoto;
